import { PREFIX_ACTIONS } from './constants';
import { IApiGetDemoDataParam, IApiGetPlaylistParam } from '../interfaces/api';
import { createAction, createAsyncAction } from 'services/actionConfigs';

const getDemoData = createAsyncAction<IApiGetDemoDataParam>(PREFIX_ACTIONS + 'getDemoData');
const getListPlaylists = createAsyncAction<IApiGetPlaylistParam>(PREFIX_ACTIONS + 'getListPlaylists');
const setPlaylistsParam = createAction<IApiGetPlaylistParam>(PREFIX_ACTIONS + 'setPlaylistsParam');

/**
 * TODO:
 * please replace channel to your feature name
 * ex:
 * playlistActions => bookingActions
 */
const playlistActions = {
  getDemoData,
  getListPlaylists,
  setPlaylistsParam,
};

export default playlistActions;

